<div class="custom-certificate">
    <div class="custom-certificate__label">{{"CERTIFICATE.CLIENT_CERTIFICATE" | translate}}</div>
    <div class="custom-certificate__checks">
        <bzg-checkbox [checked]="customCertificate.EnableOdataValidation" [ngModel]="customCertificate.EnableOdataValidation" (ngModelChange)="changeEnableOptions(1)">
            {{'CERTIFICATE.ENABLE_ODATA' | translate}}
        </bzg-checkbox>
        <bzg-checkbox [checked]="customCertificate.EnableAsmxValidation" [ngModel]="customCertificate.EnableAsmxValidation" (ngModelChange)="changeEnableOptions(2)">
            {{'CERTIFICATE.ENABLE_ASMX' | translate}}
        </bzg-checkbox>
        <bzg-checkbox [checked]="customCertificate.EnableWsSecurityValidation" [ngModel]="customCertificate.EnableWsSecurityValidation" (ngModelChange)="changeEnableOptions(3)">
            {{'CERTIFICATE.ENABLE_WSSECURITY' | translate}}
        </bzg-checkbox>
    </div>
    <!-- <div>
        <bzg-input name="clientSecret" [(ngModel)]="customCertificate.ClientCertificatePassword" type="{{showPassword ? 'text':'password'}}"
            (blur)="encryptPassword()" [maxlength]="maxLengthPassword()" actionIcnPosition="right"
            class="bz-environment-popular__required" required
            [placeholder]="'ENVIRONMENT.EMAIL_OAUTH_CLIENT_SECRET' | translate">
            {{'ENVIRONMENT.EMAIL_OAUTH_CLIENT_SECRET' | translate}}
            <bzg-required-error>{{'ENVIRONMENT.FIELD_REQUIRED' | translate}}</bzg-required-error>
            <bzg-icon nameIcon="icon-eye" *ngIf="showPassword" (click)="showEncrypt()" class="bz-environment-popular__pointer"></bzg-icon>
            <bzg-icon nameIcon="icon-eye-closed" *ngIf="!showPassword" (click)="showEncrypt()" class="bz-environment-popular__pointer"></bzg-icon>
        </bzg-input>
    </div> -->

    <!-- <button type="button" class="btn btn-default bz-button btn-configuration__detail btn-hover" (click)='onPassword()'
        title="{{'PASSWORD_PACAKGE.TITLE_BUTTON_PASSWORD'| translate}}"
        [ngClass]="{'icon-configuration-inactive__detail': !passwordAssigned}">
        <app-svg-icons icon="icon-lock-open" class="icon__detail icon-configuration__detail" *ngIf='!passwordAssigned'></app-svg-icons>
        <app-svg-icons icon="icon-lock-closed" class="icon__detail icon-configuration__detail" *ngIf='passwordAssigned'></app-svg-icons>
    </button> -->
    <div class="custom-certificate__load" [ngClass]="{ 'custom-certificate__load-end': !customCertificate.ClientCertificateName , 'custom-certificate__load-space': customCertificate.ClientCertificateName }">
        <div class="custom-certificate__load-file" *ngIf="customCertificate.ClientCertificateName">
            <div class="custom-certificate__load-file-label">{{"CERTIFICATE.UPLOAD_CERTIFICATE" | translate}}:</div>
            <div class="custom-certificate__load-file-box">
                <span>{{customCertificate.ClientCertificateName}}</span>
                <bzg-button-icon class="custom-certificate__load-file-box-close" icon="icn-close" (click)="confirmDelete()"></bzg-button-icon>
            </div>
        </div>
        
        <div class="custom-certificate__load-buttons">
            <input type="file" #fileInput (change)="onFileSelected($event)" style="display: none;">
            <bzg-button-secondary *ngIf="!customCertificate.ClientCertificateName" [icon]="'icon-upload'" (click)="uploadCertificate()">
                {{'CERTIFICATE.UPLOAD' | translate}}
            </bzg-button-secondary>
            <bzg-button-secondary class="custom-certificate__load-buttons-lock" *ngIf="customCertificate.ClientCertificateName && !customCertificate.ClientCertificatePassword" [icon]="'icon-lock-open'" (click)="showModalPassword()">
            </bzg-button-secondary>
            <bzg-button-secondary class="custom-certificate__load-buttons-unlock" *ngIf="customCertificate.ClientCertificateName && customCertificate.ClientCertificatePassword" [icon]="'icon-lock-closed'" (click)="showModalPassword()">
            </bzg-button-secondary>
            <bzg-button-primary [disabled]="!customCertificate.ClientCertificateName" (click)="saveCertificate()">
                {{'GLOBAL.SAVE' | translate}}
            </bzg-button-primary>
        </div>
    </div>
</div>